module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/lung_header_img-76715c2e5f6598c1b357051a341548f1.png";